import React, { useState, useEffect } from "react";
import { Spin } from "antd";

const DoubleHalfBanner = (props) => {
  const config = "https://s3.amazonaws.com/www.nocapvote.com";
  const [bannerLeft, setBannerLeft] = useState(null);
  const [bannerRight, setBannerRight] = useState(null);
  const [bannerMiddle, setBannerMiddle] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAds = async () => {
      try {
        setLoading(true);
        const left = await props.getAd("double-half-banner-left", props.page);
        setBannerLeft(left);
        const right = await props.getAd("double-half-banner-right", props.page);
        setBannerRight(right);
        const middle = await props.getAd("double-half-banner-middle", props.page);
        setBannerMiddle(middle);
        console.log(left);
        console.log(right);
        console.log(middle);
      } catch (e) {
        setError(e);
        console.error("Error loading ads:", e);
      } finally {
        setLoading(false);
      }
    };

    fetchAds();
  }, [props.page]); // eslint-disable-line

  if (error) {
    // Silently fail for ads - don't show error message
    console.error("Ad loading error:", error);
    return null;
  }

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        minHeight: '150px',
        padding: '20px'
      }}>
        <Spin />
      </div>
    );
  }

  return (
    <div className="double-half-banner">
      {bannerLeft && (
        <div className="double-half-container">
          <img
            className="item-1"
            alt="banner left"
            src={`${config}${bannerLeft}`}
          />
        </div>
      )}
      {bannerMiddle && (
        <div className="double-half-container">
          <img
            className="item-2"
            alt="banner middle"
            src={`${config}${bannerMiddle}`}
          />
        </div>
      )}
      {bannerRight && (
        <div className="double-half-container">
          <img
            className="item-3"
            alt="banner right"
            src={`${config}${bannerRight}`}
          />
        </div>
      )}
    </div>
  );
};

export default DoubleHalfBanner;